export default "__VITE_ASSET__Bsf2LAAG__"